import React from 'react';
import {AppContext} from "../../HomePage";
import {LanguageService} from "../../service/LanguageService";

// HomePage reads `t` from useTranslation, so changing the language here
// re-renders the whole tree without a reload.
const AuthLanguageSwitcher = () => {

    const {t} = React.useContext(AppContext);

    const current = LanguageService.getLanguage();

    return <div className="auth-ux__lang" role="group" aria-label={t('login.language_switcher')}>
        {LanguageService.getLanguages().map(language =>
            <button type="button" key={language.value}
                    className={"auth-ux__lang-btn" + (current === language.value ? " is-active" : "")}
                    aria-pressed={current === language.value}
                    onClick={() => LanguageService.setLanguage(language.value)}>
                {language.value.toUpperCase()}
            </button>)}
    </div>;
};
export default AuthLanguageSwitcher;
